var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 13.75C2.75 16.1887 5.5 18.6331 11 21.0833C16.5 18.6388 19.25 16.1944 19.25 13.75C19.25 13.4003 19.2516 12.653 19.2535 11.7284C19.2592 9.01731 19.2681 4.78242 19.25 4.58329C19.25 3.87967 18.98 3.71614 18.2326 3.26356C18.0063 3.12653 17.7362 2.963 17.4167 2.74996C16.0417 1.83329 13.7456 0.916626 11 0.916626C7.84961 0.916626 4.73164 2.65109 4.58333 2.74996C4.26377 2.963 3.99372 3.12653 3.76743 3.26356C3.02005 3.71614 2.75 3.87967 2.75 4.58329V13.75ZM17.4184 12.6084C17.4172 13.1851 17.4167 13.5388 17.4167 13.75C17.4167 15.138 15.3745 17.0259 11.0008 19.0685C6.62668 17.0213 4.58333 15.1327 4.58333 13.75V4.91635C4.62021 4.89345 4.65949 4.86908 4.70049 4.84364C4.99691 4.65975 5.38325 4.42007 5.60028 4.27538C6.44292 3.71363 9.01825 2.74996 11 2.74996C13.0718 2.74996 15.0465 3.37322 16.3997 4.27538C16.6168 4.42008 17.0031 4.65977 17.2996 4.84367C17.3438 4.87112 17.3861 4.89734 17.4254 4.9218C17.4274 5.46496 17.4283 7.22113 17.4249 9.26726C17.4242 9.74161 17.4232 10.2387 17.4221 10.8179L17.4184 12.6084Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.1bcfb6725081d1df8aeefdfadea4ca9b.svg";
export { ForwardRef as ReactComponent };